module.exports = __webpack_public_path__ + "static/profile-c3972ec9edf70907faf79683954c7fdf.jpg";